import { storeStructure } from '../store/reducers';
import tableLive from './tableLive';

export default {
  title: 'Live Events',
  attributeName: 'lives',
  getURL: 'live',
  createURL: '',
  updateURL: 'liveStatus',
  removeURL: 'live',
  sessionParams: [],
  noArea: true,
  tableConfig: tableLive,
  removeReconfirmMessage:'Are you sure you want to delete this live having the following items related?',
  removeReconfirmURL:'listremovelivedetail',
  removeNameField:'name',
  removeText:'You are about to remove the live event with name ##name##.',
  // websocketNavigation:'users_navigation',
  websocketEventChanel: 'live',
  websocketItem: 'live',
  
  autoUpdate: true,
};
